<template>
  <div class="pages">
    <navTop :acIndex="0"></navTop>
    <div class="box">
      <!-- 订单分类 -->
      <div class="order-top">
        <div class="li" :class="{ active: acIndex == n }" @click="goLi(n)"
             v-for="(m, n) in orderTopList" :key="n">
          {{ m.text }}
        </div>
      </div>
      <!-- 订单搜索 -->
      <div class="order-search">
        <input type="text" v-model="keyword" placeholder="Please enter" />
        <p @click="fnSeacher"><img src="../../assets/search.png" /></p>
      </div>
      <!-- 订单为空 -->
      <div class="empty" v-if="orderList.length == 0">
        <img src="https://www.mescroll.com/img/mescroll-empty.png" />
        <p>No order</p>
      </div>
      <!-- 订单顶部 -->
      <div class="order-nav" v-if="orderList.length > 0">
        <p>Information</p>
        <p>Type</p>
        <p>Price</p>
        <p>State</p>
        <p>AdditionalCost</p>
        <p>Operation</p>
      </div>
      <!-- 订单内容 -->
      <div class="order-content" v-if="orderList.length > 0">
        <div class="order-item" v-for="(item, index) in orderList" :key="index"
             @click="goOrderDetails(item.id)">
          <div class="service">
            <div class="order-number">orderNumber：{{ item.orderNum }}</div>
            <div class="service-top">{{ item.serveTitle }}</div>
            <div class="service-bottom">
              <div class="service-bottom-left">
                <img :src="item.servePic" />
              </div>
              <div class="service-bottom-right">
                {{ item.docName}}
              </div>
            </div>
          </div>
          <div class="info-column type-column">
            <div class="info-content" v-if="item.serveType == 0">
              Supervision of loading
            </div>
            <div class="info-content" v-if="item.serveType == 1">Measure oil</div>
            <div class="info-content" v-if="item.serveType == 2">Come on.</div>
            <div class="info-content" v-if="item.serveType == 3">Draft</div>
            <div class="info-content" v-if="item.serveType == 4">Insurance</div>
          </div>
          <div class="info-column price-column">
            <div class="info-content">${{ item.price }}</div>
          </div>
          <div class="info-column status-column">
            <div class="info-content">
              <span v-if="item.isPause == 0 && item.status == 0">
                Pending payment
              </span>
              <span v-if="item.isPause == 0 && item.status == 1">
                To be received by the inspector
              </span>
              <span v-if="item.isPause == 0 && item.status == 2">
                Order cancelled
              </span>
              <span v-if="item.isPause == 0 && item.status == 3">
                Inspector to go
              </span>
              <span v-if="item.isPause == 0 && item.status == 4">
                The surveyor has set out
              </span>
              <span @click.stop="getschedule(item)"
                    v-if="item.isPause == 0 && item.status == 5">
                The inspector has arrived
              </span>
              <span v-if="item.isPause == 0 && item.status == 6">
                The inspector is working
              </span>
              <span v-if="item.isPause == 0 && item.status == 7">
                Uploaded certificate
              </span>
              <span v-if="item.isPause == 0 && item.status == 8">
                Inspector completed
              </span>
              <span v-if="item.isPause == 0 && item.status == 9">
                To be evaluated
              </span>
              <span v-if="item.isPause == 0 && item.status == 10">Evaluated</span>
              <span v-if="item.isPause == 0 && item.status == 11">
                Inspector rejected
              </span>
              <span v-if="item.isPause == 0 && item.status == 12">Refunded</span>
              <span v-if="item.isPause == 1">Refund under review</span>
              <span v-if="item.isPause == 2">Additional charges to be paid</span>
              <span v-if="item.isPause == 3">Urgent report to be reviewed</span>
              <span v-if="item.isPause == 4">User insurance to be paid</span>
              <span v-if="item.isPause == 5">After sales audit in progress</span>
            </div>
          </div>
          <div class="info-column fee-column">
            <div class="info-content">${{ item.addFee || 0 }}</div>
          </div>
          <div class="operation-column">
            <div class="operation">
              <!-- ==0 ==0 -->
              <div class="btn btn1" v-if="item.isPause == 0 && item.status == 0"
                   @click.stop="goPay(item)">
                To pay
              </div>
              <div class="btn btn2" v-if="item.isPause == 0 && item.status == 0"
                   @click.stop="cancelOrder(item.id)">
                Cancellation of order
              </div>
              <!-- ==0 ==1 -->
              <div class="btn btn2" v-if="item.isPause == 0 && item.status == 1"
                   @click.stop="cancelOrder(item.id)">
                Cancellation of order
              </div>
              <!-- ==0 ==3 -->
              <el-badge :value="item.hasMsg" :max="10"
                        v-if="item.isPause == 0 && item.status == 3">
                <div class="btn btn2" @click.stop="remind(item.id)">
                  Notification reminder
                </div>
              </el-badge>
              <div class="btn btn2" v-if="item.isPause == 0 && item.status == 3"
                   @click.stop="refund(item.id)">
                Refund
              </div>
              <!-- ==0 ==4 -->
              <el-badge :value="item.hasMsg" :max="10"
                        v-if="item.isPause == 0 && item.status == 4">
                <div class="btn btn2" @click.stop="remind(item.id)">
                  Notification reminder
                </div>
              </el-badge>
              <div class="btn btn2" v-if="item.isPause == 0 && item.status == 4"
                   @click.stop="aftersales(item.id)">
                After sale
              </div>
              <!-- ==0 ==5 -->
              <el-badge :value="item.hasMsg" :max="10"
                        v-if="item.isPause == 0 && item.status == 5">
                <div class="btn btn2" @click.stop="remind(item.id)">
                  Notification reminder
                </div>
              </el-badge>
              <div class="btn btn2" v-if="item.isPause == 0 && item.status == 5"
                   @click.stop="viewPhotos(item.arrivePic)">
                View Photos
              </div>
              <div class="btn btn2" v-if="item.isPause == 0 && item.status == 5"
                   @click.stop="aftersales(item.id)">
                After sale
              </div>
              <div class="btn btn2" v-if="item.isPause == 0 && item.status == 5"
                   @click.stop="getschedule(item)">
                View progress
              </div>
              <!-- ==0 ==6 -->
              <el-badge :value="item.hasMsg" :max="10"
                        v-if="item.isPause == 0 && item.status == 6">
                <div class="btn btn2" @click.stop="remind(item.id)">
                  Notification reminder
                </div>
              </el-badge>
              <div class="btn btn2" v-if="item.isPause == 0 && item.status == 6"
                   @click.stop="getschedule(item)">
                View progress
              </div>
              <div class="btn btn2" v-if="item.isPause == 0 && item.status == 6"
                   @click.stop="aftersales(item.id)">
                After sale
              </div>
              <!-- ==0 ==8 -->
              <div class="btn btn2" v-if="item.isPause == 0 && item.status == 8"
                   @click.stop="getschedule(item)">
                View progress
              </div>
              <div class="btn btn2" v-if="item.isPause == 0 && item.status == 8"
                   @click.stop="confirmacceptance(item.id)">
                Acceptance
              </div>
              <div class="btn btn2" v-if="item.isPause == 0 && item.status == 8"
                   @click.stop="aftersales(item.id)">
                After sale
              </div>
              <!-- ==0 ==9 -->
              <div class="btn btn2" v-if="item.isPause == 0 && item.status == 9"
                   @click.stop="getschedule(item)">
                View progress
              </div>
              <div class="btn btn2" v-if="item.isPause == 0 && item.status == 9"
                   @click.stop="getEvaluate(item.id)">
                To evaluate
              </div>
              <div class="btn btn2" v-if="item.isPause == 0 && item.status == 9"
                   @click.stop="aftersales(item.id)">
                After sale
              </div>
              <!-- ==0 ==10 -->
              <div class="btn btn2" v-if="item.isPause == 0 && item.status == 10"
                   @click.stop="getschedule(item)">
                View progress
              </div>
              <div class="btn btn2" v-if="item.isPause == 0 && item.status == 10"
                   @click.stop="aftersales(item.id)">
                After sale
              </div>
              <!-- ==0 ==11 -->
              <div class="btn btn2" v-if="item.isPause == 0 && item.status == 11">
                View details
              </div>
              <!-- ==0 ==12 -->
              <div class="btn btn2" v-if="item.isPause == 0 && item.status == 12">
                View details
              </div>
              <!-- !=0  2 -->
              <el-badge :value="item.hasMsg" :max="10" v-if="item.isPause == 2">
                <div class="btn btn2" @click.stop="remind(item.id)">
                  Notification reminder
                </div>
              </el-badge>
              <div class="btn btn1" v-if="item.isPause == 2"
                   @click.stop="goPay(item)">
                To pay
              </div>
              <div class=" btn btn2" v-if="item.isPause == 2"
                   @click.stop="refund(item.id)">
                Refund
              </div>
              <!-- !=0 3 -->
              <div class="btn btn3" v-if="item.isPause == 3"
                   @click.stop="getreport(item.accidentReason)">
                View emergency escalation reasons
              </div>
              <!-- !=0 4 -->
              <div class="btn btn1" v-if="item.isPause == 4"
                   @click.stop="goPay(item)">
                To pay
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <navFooter></navFooter>
  </div>
</template>

<script>
import navTop from '../../components/navTop.vue';
import navFooter from '../../components/navFooter.vue';
export default {
  name: 'order',
  components: {
    navTop,
    navFooter
  },
  data() {
    return {
      orderTopList: [
        {text: 'All orders'},
        {text: 'Pending payment'},
        {text: 'To be served'},
        {text: 'To be verified'},
        {text: 'To be evaluated'},
        {text: 'Refund after sales'}
      ], //订单分类
      acIndex: 0, //订单分类下标
      keyword: '',
      orderList: []
    };
  },
  created() {
    if (!sessionStorage.getItem('uid')) {
      this.$router.push({path: '/'});
    } else {
      this.getOrderlist();
    }
  },
  methods: {
    order() {
      console.log('3333333')
    },
    // 订单列表
    getOrderlist() {
      let data = {
        uid: sessionStorage.getItem('uid'),
        type: this.acIndex,
        key: this.keyword,
        nowPage: 1,
        pageCount: 10000
      };
      this.$api.orderlist(data).then(res => {
        if (res.result == 0) {
          this.orderList = res.data.list;
          res.data.list.forEach(item => {
            console.log(item.status)
          })
        }
      });
    },
    // 搜索列表
    fnSeacher() {
      this.acIndex = 6;
      this.getOrderlist();
    },
    // 切换订单分类
    goLi(i) {
      this.acIndex = i;
      this.getOrderlist();
    },
    // 订单详情
    goOrderDetails(id) {
      this.$router.push({path: '/orderDetails', query: {id: id}});
    },

    // 去付款
    goPay(item) {
      console.log(item);
      if (item.isPause == 2) {
        this.$router.push({
          path: '/pay',
          query: {
            id: item.id,
            sum: item.addFee,
            serveType: item.serveType,
            num: 0
          }
        });
      } else {
        this.$router.push({
          path: '/pay',
          query: {
            id: item.id,
            sum: item.price,
            serveType: item.serveTypenum,
            num: 1
          }
        });
      }
    },
    // 取消订单
    cancelOrder(id) {
      this.$api.beforecancel({id: id}).then(res => {
        console.log(res);
        if (res.result == 0) {
          if (res.data.isPay == 0) {
            this.$router.push({path: '/cancel', query: {id: id}});
          } else {
            this.$router.push({
              path: '/overtimeCancel',
              query: {id: id, money: res.data.money}
            });
          }
        }
      });
    },
    // 通知提醒
    remind(id) {
      this.$router.push({path: '/noticeRemind', query: {id: id}});
    },
    // 查看照片
    viewPhotos(arrivePic) {
      this.$router.push({path: '/see', query: {arrivePic: arrivePic}});
    },
    // 紧急上报原因
    getreport(accidentReason) {
      this.$router.push({
        path: '/report',
        query: {accidentReason: accidentReason}
      });
    },
    // 申请退款
    refund(id) {
      this.$router.push({path: '/applyRefund', query: {id: id}});
    },
    //申请售后
    aftersales(id) {
      this.$router.push({path: '/applyAftersales', query: {id: id}});
    },
    // 确定验收
    confirmacceptance(id) {
      let data = {
        id: id
      };
      this.$api.confirm(data).then(res => {
        console.log(res);
        if (res.result == 0) {
          this.getOrderlist();
        }
      });
    },
    /*
     *选择查看进度、报告
     *0监装1量油2加油3水尺4保险
     */
    getschedule(item) {
      console.log(item)
      // return false
      this.$router.push({
        path: '/schedule',
        query: {id: item.id, type: item.serveType}
      });
    },
    // 去评价
    getEvaluate(id) {
      this.$router.push({path: '/evaluate', query: {id: id}});
    }
  }
};
</script>

<style lang="scss" scoped>
// 科技蓝色风格变量 - 使用 #1ba8e8 作为主色调
$blue-primary: #1ba8e8;
$blue-primary-rgba: rgba(27, 168, 232, 0.9);
$blue-secondary: #4ab9f0;
$blue-glow: rgba(27, 168, 232, 0.4);
$blue-light: rgba(27, 168, 232, 0.2);
$blue-dark: #0f2b3f;
$text-glow: 0 0 8px rgba(27, 168, 232, 0.5);

// 导航栏样式覆盖 - 降低高度
::v-deep .nav {
  height: 60px !important;

  .main {
    height: 60px !important;

    .nav_right {
      height: 60px !important;

      .text {
        height: 60px !important;

        span:nth-child(1) {
          height: 60px !important;
          line-height: 60px !important;
        }
      }
    }
  }
}

.pages {
  background: linear-gradient(135deg, #0f2b3f 0%, #1a3f5a 100%);
  position: relative;
  min-height: 10vh;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 30%, rgba(27, 168, 232, 0.1) 0%, transparent 50%);
    pointer-events: none;
  }

  .box {
    position: relative;
    padding-top: 10px;
    padding-bottom: 80px;
    box-sizing: border-box;
    max-width: 1400px;
    margin: 0 auto;
    z-index: 2;

    // 订单分类
    .order-top {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 12px;
      margin-top: 10px;

      .li {
        width: 160px;
        height: 38px;
        font-size: 16px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: $blue-primary;
        background: rgba(27, 168, 232, 0.1);
        border: 1px solid $blue-primary-rgba;
        border-radius: 30px;
        text-align: center;
        line-height: 38px;
        margin-right: 15px;
        cursor: pointer;
        transition: all 0.3s ease;
        box-shadow: 0 0 10px $blue-glow;
        text-shadow: 0 0 5px $blue-glow;

        &:hover {
          background: rgba(27, 168, 232, 0.2);
          box-shadow: 0 0 18px $blue-primary;
          transform: translateY(-2px);
        }
      }

      .active {
        background: $blue-primary;
        color: #ffffff;
        border-color: $blue-primary;
        box-shadow: 0 0 22px $blue-primary;
        text-shadow: 0 0 10px rgba(255, 255, 255, 0.5);

        &:hover {
          background: lighten($blue-primary, 10%);
        }
      }
    }

    // 订单搜索
    .order-search {
      margin-top: 20px;
      width: 100%;
      height: 38px;
      box-shadow: 0 0 12px $blue-glow;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 5px;
      overflow: hidden;

      input {
        width: 100%;
        border: 1px solid $blue-primary;
        height: 38px;
        outline: none;
        background: rgba(15, 43, 63, 0.8);
        color: $blue-primary;
        padding: 0 10px;
        box-sizing: border-box;
        border-radius: 5px 0 0 5px;
        font-size: 14px;
        transition: all 0.3s ease;

        &:focus {
          box-shadow: 0 0 10px $blue-primary inset;
          background: rgba(15, 43, 63, 0.95);
        }

        &::placeholder {
          color: rgba(27, 168, 232, 0.5);
        }
      }

      p {
        width: 42px;
        height: 38px;
        border: 1px solid $blue-primary;
        border-left: none;
        box-shadow: 0 0 10px $blue-glow;
        border-radius: 0 5px 5px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(27, 168, 232, 0.2);
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          background: rgba(27, 168, 232, 0.4);
          box-shadow: 0 0 18px $blue-primary;
        }

        img {
          width: 18px;
          height: 20px;
          display: block;
          filter: brightness(1.2) drop-shadow(0 0 5px $blue-primary);
        }
      }
    }

    // 暂无订单
    .empty {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      img {
        display: block;
        margin-top: 60px;
        opacity: 0.7;
        filter: drop-shadow(0 0 10px $blue-glow);
      }

      p {
        font-size: 20px;
        color: $blue-primary;
        margin-top: 15px;
        text-shadow: $text-glow;
      }
    }

    // 订单顶部
    .order-nav {
      margin-top: 25px;
      width: 100%;
      height: 50px;
      background: linear-gradient(90deg, $blue-primary 0%, $blue-secondary 100%);
      border-radius: 6px 6px 0px 0px;
      padding: 0 30px 0 15px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      box-shadow: 0 0 22px $blue-primary;

      p {
        flex: 1;
        font-size: 18px;
        color: #ffffff;
        line-height: 1em;
        text-align: center;
        font-weight: bold;
        text-shadow: 0 0 6px rgba(255, 255, 255, 0.5);
        white-space: nowrap;
      }

      p:nth-child(1) {
        flex: 1.5;
      }
    }

    // 订单内容
    .order-content {
      margin-top: 25px;
      padding-bottom: 60px;

      .order-item {
        width: 100%;
        min-height: 200px;
        border: 1px solid $blue-primary-rgba;
        border-radius: 6px;
        background: rgba(15, 43, 63, 0.8);
        backdrop-filter: blur(6px);
        margin-bottom: 15px;
        padding: 15px 30px 15px 15px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        box-shadow: 0 0 20px $blue-glow;
        transition: all 0.3s ease;
        cursor: pointer;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 25px $blue-primary;
          border-color: $blue-primary;
        }

        .service {
          flex: 1.5;
          min-width: 0;
          padding-right: 10px;

          .order-number {
            font-size: 13px;
            color: $blue-primary;
            text-shadow: $text-glow;
            margin-bottom: 8px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .service-top {
            font-size: 15px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #ffffff;
            line-height: 1.2em;
            text-align: right;
            padding-left: 150px;
            box-sizing: border-box;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-shadow: 0 0 5px $blue-glow;
            margin-bottom: 8px;
          }

          .service-bottom {
            display: flex;
            align-items: center;

            .service-bottom-left {
              width: 160px;
              height: 90px;
              background: linear-gradient(135deg, $blue-primary 0%, $blue-secondary 100%);
              border-radius: 6px;
              padding: 6px 8px;
              box-sizing: border-box;
              box-shadow: 0 0 15px $blue-glow;
              flex-shrink: 0;

              img {
                width: 100%;
                height: 100%;
                display: block;
                border-radius: 3px;
                object-fit: cover;
              }
            }

            .service-bottom-right {
              width: 140px;
              height: 70px;
              background: rgba(27, 168, 232, 0.15);
              border: 1px solid $blue-primary-rgba;
              border-radius: 6px;
              margin-left: 25px;
              padding: 20px 0 0 25px;
              box-sizing: border-box;
              text-align: center;
              font-size: 16px;
              color: #ffffff;
              line-height: 1.2em;
              box-shadow: 0 0 12px $blue-glow inset;
              text-shadow: 0 0 5px $blue-primary;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }

        .info-column {
          flex: 1;
          min-width: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 5px;
          height: 100%;

          .info-content {
            width: 100%;
            text-align: center;
            color: #c0e4ff;
            font-size: 16px;
            line-height: 1.3em;
            word-break: break-word;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            span {
              color: #c0e4ff;
              font-size: 14px;
              text-align: center;
              width: 100%;
              display: block;
              margin-bottom: 4px;

              &:hover {
                color: $blue-primary;
                text-shadow: $text-glow;
              }

              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }

        .price-column, .fee-column {
          .info-content {
            font-weight: bold;
            color: $blue-primary;
            font-size: 18px;
          }
        }

        // 修改：让李总这个框（服务名称框）完全居中
        .service .service-bottom .service-bottom-right {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
          text-align: center;
        }

        .operation-column {
          flex: 1;
          min-width: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 5px;

          .operation {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 5px;

            .el-badge {
              width: 100%;
            }

            .btn {
              width: 100%;
              margin-bottom: 0;
              box-shadow: 0 0 5px $blue-primary inset;
              text-align: center;
              line-height: 1.2em;
              font-size: 14px;
              padding: 6px 0;
              box-sizing: border-box;
              border-radius: 4px;
              cursor: pointer;
              transition: all 0.3s ease;

              &:hover {
                transform: translateY(-2px);
                box-shadow: 0 0 12px $blue-primary;
              }
            }

            .btn1 {
              background: rgba(27, 168, 232, 0.3);
              border: 1px solid $blue-primary;
              color: #ffffff;

              &:hover {
                background: rgba(27, 168, 232, 0.5);
              }
            }

            .btn2 {
              border: 1px solid $blue-primary;
              color: $blue-primary;
              background: rgba(27, 168, 232, 0.1);

              &:hover {
                background: rgba(27, 168, 232, 0.2);
                color: lighten($blue-primary, 10%);
              }
            }

            .btn3 {
              border: 1px solid $blue-primary;
              color: $blue-primary;
              padding: 6px 8px;
              box-sizing: border-box;
              background: rgba(27, 168, 232, 0.1);
              font-size: 13px;
              line-height: 1.2;

              &:hover {
                background: rgba(27, 168, 232, 0.2);
              }
            }
          }
        }
      }

      .order-item:last-child {
        margin: 0;
      }
    }
  }
}

// 底部样式
::v-deep .footer {
  background: linear-gradient(90deg, #0f2b3f 0%, #1a3f5a 100%) !important;
  border-top: 2px solid $blue-primary !important;
  box-shadow: 0 -5px 25px $blue-glow !important;
  position: relative;
  z-index: 2;

  .footer-left {
    .logo {
      filter: drop-shadow(0 0 10px $blue-primary);
    }

    .text {
      color: #c0e4ff !important;

      span {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }
    }
  }

  .footer-right {
    .service {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .list {
        .li {
          color: #c0e4ff !important;

          &:hover {
            color: $blue-primary !important;
            text-shadow: $text-glow;
          }
        }
      }
    }

    .contact {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .item {
        color: #c0e4ff !important;

        img {
          filter: brightness(1.2) drop-shadow(0 0 5px $blue-primary);
        }
      }
    }

    .qrcode {
      border: 1px solid $blue-primary !important;
      box-shadow: 0 0 20px $blue-glow;
    }
  }

  // 其他网站区域
  .other-site {
    border-top: 1px solid rgba(27, 168, 232, 0.3) !important;
    margin-top: 30px !important;
    padding-top: 30px !important;

    .other-site-title {
      color: $blue-primary !important;
      font-size: 18px !important;
      font-weight: bold !important;
      margin-bottom: 15px !important;
      text-shadow: $text-glow;
      position: relative;
      display: inline-block;

      &::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 50px;
        height: 2px;
        background: $blue-primary;
        box-shadow: 0 0 10px $blue-primary;
      }
    }

    .other-site-links {
      display: flex !important;
      flex-wrap: wrap !important;
      gap: 15px !important;
      margin-bottom: 20px !important;

      .other-site-link-item {
        color: #c0e4ff !important;
        font-size: 14px !important;
        padding: 5px 15px !important;
        border: 1px solid rgba(27, 168, 232, 0.2) !important;
        border-radius: 20px !important;
        transition: all 0.3s ease !important;
        cursor: pointer !important;

        &:hover {
          border-color: $blue-primary !important;
          box-shadow: 0 0 15px $blue-glow !important;
          color: $blue-primary !important;
          transform: translateY(-2px);
        }
      }
    }

    .other-site-copyright {
      color: #c0e4ff !important;
      font-size: 13px !important;
      line-height: 1.8 !important;
      text-align: center !important;

      a {
        color: $blue-primary !important;
        text-decoration: none !important;
        transition: all 0.3s ease !important;

        &:hover {
          color: lighten($blue-primary, 20%) !important;
          text-shadow: $text-glow;
        }
      }

      .icp {
        color: #c0e4ff !important;
        margin: 0 5px;

        span {
          color: $blue-primary !important;
        }
      }

      .beian {
        color: #c0e4ff !important;
        margin: 0 5px;

        a {
          color: $blue-primary !important;
        }
      }

      .company {
        color: $blue-primary !important;
        font-weight: bold;
      }
    }
  }
}

// 响应式调整
@media screen and (max-width: 1200px) {
  .pages {
    .box {
      padding-left: 15px;
      padding-right: 15px;

      .order-top {
        .li {
          width: 140px;
          font-size: 14px;
          height: 35px;
          line-height: 35px;
          margin-right: 10px;
        }
      }

      .order-nav {
        p {
          font-size: 15px;
        }
      }

      .order-content {
        .order-item {
          padding: 12px 20px 12px 12px;

          .service {
            .order-number {
              font-size: 12px;
            }

            .service-top {
              font-size: 14px;
              padding-left: 120px;
            }

            .service-bottom {
              .service-bottom-left {
                width: 130px;
                height: 75px;
              }

              .service-bottom-right {
                width: 120px;
                font-size: 14px;
                height: 60px;
                padding: 0;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
          }

          .info-column {
            .info-content {
              font-size: 14px;

              span {
                font-size: 12px;
              }
            }
          }

          .price-column, .fee-column {
            .info-content {
              font-size: 16px;
            }
          }

          .operation-column {
            .operation {
              .btn {
                font-size: 12px;
                padding: 5px 0;
              }

              .btn3 {
                font-size: 11px;
                padding: 5px 6px;
              }
            }
          }
        }
      }
    }
  }
}
</style>